<template>
  <span class="h-2 w-2 relative">
    <span
      class="
        animate-ping
        absolute
        inline-flex
        w-2
        h-2
        rounded-full
        bg-brand-red
        opacity-75
      "
      v-if="ping"
    ></span>
    <span class="absolute inline-flex rounded-full h-2 w-2 bg-brand-red"></span>
  </span>
</template>
<script>
export default {
  props: {
    ping: {
      type: Boolean,
      default: false
    }
  }
}
</script>
